import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InquiryMgmtStateType, ApiGetDataStatus } from '@redux/types'
import { InquiryType } from '@schemas'

// initial state
const initialState: InquiryMgmtStateType = {
	triggerInitInquiryMgmt: false,
	inquiryListStatus: 'init',
	inquiryList: [],
}

const slice = createSlice({
	name: 'inquiryMgmt',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_INQUIRY_MGMT: (
			state: InquiryMgmtStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitInquiryMgmt = action.payload
		},

		// list
		INQUIRY_LIST_STATUS: (
			state: InquiryMgmtStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.inquiryListStatus = action.payload
		},
		INQUIRY_LIST: (state: InquiryMgmtStateType, action: PayloadAction<InquiryType[]>) => {
			state.inquiryList = action.payload
		},
	},
})

export const inquiryMgmtActions = slice.actions
export default slice.reducer
